(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ww-brand]:not([data-initialized])').forEach((section) => {
      section.dataset.initialized = 'true';
      const load = async () => {
        const grid = section.querySelector('.ww-brand__grid');
        const seen = new Set([section.dataset.currentId]);
        const visited = new Set();
        const pending = [section.dataset.secondUrl].filter(Boolean);
        let next = section.dataset.vendorUrl;
        try {
          while (next) {
            const url = new URL(next, location.origin);
            url.searchParams.set('section_id', 'ww-brand-products');
            if (visited.has(url.href)) break;
            visited.add(url.href);
            const response = await fetch(url.href, { credentials: 'same-origin' });
            if (!response.ok) break;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const results = doc.querySelector('[data-ww-brand-results]');
            if (!results) break;
            results.querySelectorAll('[data-product-id]').forEach((card) => {
              if (seen.has(card.dataset.productId)) return;
              seen.add(card.dataset.productId);
              grid.append(card);
            });
            next = results.dataset.next || pending.shift();
          }
        } catch (_) {
          return;
        }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            load();
          }
        }, { rootMargin: '600px' });
        observer.observe(section);
      } else load();
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
